export const de = {
  form: {
    first_name: 'Vorname',
    last_name: 'Nachname',
    email: 'E-Mail-Adresse',
    phone: 'Telefonnummer',
    business_type: 'Unternehmensart',
    first_name_placeholder: 'Max',
    last_name_placeholder: 'Mustermann',
    email_placeholder: 'max@beispiel.de',
    phone_placeholder: '+49 123 456789',
    business_types: {
      e_commerce: 'E-Commerce',
      saas: 'SaaS',
      service_provider: 'Dienstleister',
      local_business: 'Lokales Unternehmen',
      other: 'Sonstiges'
    }
  },
  analysis_form: {
    website: 'Webseite',
    website_placeholder: 'https://beispiel.de',
    referral_source: 'Wie haben Sie uns gefunden?',
    referral_source_placeholder: 'Wählen Sie Ihre Antwort aus',
    challenges: 'Hauptherausforderungen',
    challenges_placeholder: 'Was sind Ihre größten Marketing- und Automatisierungsherausforderungen?',
    business_type_placeholder: 'Wäheln Sie Ihre Unternehmensart',
    submitting: 'Wird gesendet...',
    submit: 'Meine kostenlose Analyse erhalten',
    success_title: 'Vielen Dank für Ihre Analyseanfrage!',
    success_message: 'Wir werden Ihre Informationen prüfen und uns in Kürze bei Ihnen melden.',
    error_message: 'Analyseanfrage konnte nicht gesendet werden. Bitte versuchen Sie es erneut.'
  },
  footer: {
    about: {
      title: 'Über uns',
      description: 'Wir helfen Unternehmen durch strategisches Marketing und intelligente Automatisierung zu wachsen.'
    },
    legal: {
      title: 'Rechtliches',
      imprint: 'Impressum',
      privacy: 'Datenschutz'
    },
    contact: {
      title: 'Kontakt'
    },
    social: {
      title: 'Folgen Sie uns'
    },
    copyright: 'Simons Marketing Solutions. Alle Rechte vorbehalten.'
  },
  language_switch: 'Sprache wechseln',
  meta: {
    description: 'Steigern Sie Ihr Geschäft mit unseren garantierten Marketing-Ergebnissen und Automatisierungslösungen. Erhalten Sie noch heute eine kostenlose Marketing-Analyse.',
    home: {
      title: 'Marketing & Automatisierungs-Agentur | Simons Marketing Solutions',
      description: 'Transformieren Sie Ihr Unternehmen mit bewährten Marketing-Strategien und intelligenter Automatisierung. Erhalten Sie garantierte Ergebnisse mit unseren Expertenlösungen.'
    },
    analysis: {
      title: 'Kostenlose Marketing-Analyse | Simons Marketing Solutions',
      description: 'Erhalten Sie eine kostenlose, umfassende Analyse Ihres Marketing-Potenzials. Entdecken Sie Wachstums- und Automatisierungsmöglichkeiten in Ihrem Unternehmen.'
    }
  },
  free_analysis_page: {
    back: 'Zur Startseite',
    badge: 'Kostenlose Analyse',
    title: 'Holen Sie sich Ihre kostenlose',
    title_highlight: 'Google-Analyse',
    subtitle: 'Finden Sie heraus, wo Ihr Unternehmen bei Google steht und was es braucht, um in Ihrer Region in die Top 3 zu kommen.',
    form_title: 'Erzählen Sie uns von Ihrem Unternehmen',
    form_subtitle: 'Füllen Sie die Details unten aus und wir melden uns mit einer umfassenden Analyse bei Ihnen.',
    benefits_title: 'Das erhalten Sie',
    benefits: {
      google_audit: {
        title: 'Vollständiges Google-Audit',
        description: 'Wir überprüfen Ihren aktuellen Google Maps Eintrag, Rankings und Profilvollständigkeit.'
      },
      competitor: {
        title: 'Wettbewerbsanalyse',
        description: 'Sehen Sie, wie Sie im Vergleich zu den bestplatzierten Unternehmen in Ihrer Region abschneiden.'
      },
      strategy_call: {
        title: 'Strategiegespräch',
        description: 'Ein persönliches Gespräch, um Ihnen unsere Ergebnisse und empfohlenen nächsten Schritte vorzustellen.'
      },
      no_obligation: {
        title: 'Keine Verpflichtung',
        description: 'Diese Analyse ist völlig kostenlos. Keine Verträge, keine Verpflichtungen.'
      },
      quick_turnaround: {
        title: 'Schnelle Bearbeitung',
        description: 'Erhalten Sie Ihre Analyse innerhalb von 48 Stunden nach Einreichung Ihrer Daten.'
      },
      actionable: {
        title: 'Umsetzbare Erkenntnisse',
        description: 'Gehen Sie mit klaren, praktischen Schritten nach Hause, die Sie sofort umsetzen können.'
      }
    }
  },
  simonsMarketing: {
    nav: {
      advantages: 'Vorteile',
      process: 'Ablauf',
      testimonials: 'Bewertungen',
      guarantee: 'Garantie',
      questions: 'Fragen',
      free_analysis: 'Kostenlose Analyse'
    },
    hero: {
      badge: 'Google SEO',
      title_start: 'Top 3 bei Google innerhalb von 90 Tagen,',
      title_highlight: 'Garantiert.',
      subtitle_line1: '75% aller Suchanfragen gehen an die Top 3 Surchergebnisse.',
      subtitle_line2: 'Und wenn Sie nicht in den Top 3 sind, sind Sie im Grunde',
      subtitle_highlight: 'unsichtbar',
      cta_primary: 'Jetzt starten',
      cta_secondary: 'So funktioniert es'
    },
    value_proposition: {
      badge: 'Der Vorteil',
      title_prefix: 'Aber',
      title_suffix: ', lohnt sich das überhaupt?',
      features: {
        visibility: {
          title: 'Sichtbarkeit',
          description: 'Wenn potenzielle Kunden nach Unternehmen wie Ihrem suchen, finden sie Sie zuerst. In den Top 3 zu sein bedeutet, die offensichtliche Wahl in Ihrer Region zu sein.'
        },
        free: {
          title: 'Kostenlos',
          description: 'Im Gegensatz zu bezahlten Anzeigen, die jeden Monat Ihr Budget belasten, liefern Google Maps Rankings organischen Traffic ohne laufende Werbekosten. Sobald Sie ranken, kommen die Anfragen von allein.'
        },
        long_term: {
          title: 'Langfristige Strategie',
          description: 'Das ist kein kurzfristiger Trick. Eine starke Google Maps Präsenz wächst mit der Zeit, baut Vertrauen und Autorität auf und sorgt für einen stetigen Kundenstrom über Jahre hinweg.'
        }
      }
    },
    testimonials: {
      badge: 'Bewertungen',
      title_start: 'Was unsere Kunden',
      title_highlight: 'sagen',
      items: {
        anke: {
          content: 'Ich hatte keine Homepage und keine Ahnung, wie ich das ändern sollte. Simon hat das einfach gelöst. Ganz nach meinen Vorstellungen. Das Ergebnis ist eine Seite, die ich heute selbst pflege und mit der ich mehr Kunden bekomme. Und bei Fragen ist er immer noch da. Klare Empfehlung.',
          name: 'Anke D.',
          role: 'Anke Wohnambiente'
        },
        linda: {
          content: 'Für meine Praxis ist die Sichtbarkeit und die Präsentation im Internet von großer Wichtigkeit, um neue Patienten zu gewinnen. Am Anfang war ich etwas skeptisch, denn man bekommt so viele Angebote. Simon hat es geschafft, dass meine Homepage bei den Suchanfragen von der vierten Seite auf die erste Seite hochgerankt wurde und ich dadurch schon einige neue Anfragen von interessierten Patienten bekommen habe. Außerdem haben er meine Hompage zu einem neuen viel preiswerteren Anbieter übertragen. Auch hier konnte ich mir Geld sparen. Ich kann Sie in vollem Umfang weiterempfehlen.',
          name: 'L. K.',
          role: 'Heilpraktikerin'
        }
      }
    },
    process: {
      badge: 'Wie funktioniert es?',
      title: 'Es ist ziemlich',
      title_italic: 'einfach.',
      steps: {
        free_analysis: {
          title: 'Kostenlose Analyse',
          description: 'Füllen Sie Formular für die kostenlose Analyse aus.'
        },
        onboarding: {
          title: 'Onboarding',
          description: 'Wir klären in einem Call, ob wir ein guter Match sind. Wenn dem so ist, senden wir Ihnen eine detaillierte Anleitung, die zeigt, wie wir sicheren Zugriff auf Ihr Profil erhalten.'
        },
        execution: {
          title: 'Umsetzung',
          description: 'Wir gehen jeden Schritt des Prozesses mit Ihnen durch, damit wir Ihren Kalender nicht nur für Wochen füllen. Über die Zeit der Zusammenarbeit erhalten Sie regelmäßige Updates über die Vortschritte.'
        },
        what_works: {
          title: 'Was funktioniert?',
          description: 'Wir verfolgen relevante Daten, um zu sehen, was tatsächlich funktioniert, und passen die Strategie so an, dass wir das meiste für Sie herausholen.'
        }
      }
    },
    faq: {
      badge: 'FAQs',
      title_start: 'Häufig gestellte',
      title_bold: 'Fragen',
      items: {
        seo_vs_ads: {
          question: 'Was ist der Unterschied zwischen SEO und Google Ads?',
          answer: 'SEO (Suchmaschinenoptimierung) konzentriert sich auf die Verbesserung Ihrer organischen Suchrankings durch Content-Optimierung, technische Verbesserungen und den Aufbau von Autorität. Google Ads ist eine bezahlte Werbeplattform, bei der Sie für jeden Klick bezahlen. Der entscheidende Unterschied ist die Nachhaltigkeit: SEO baut langfristige Sichtbarkeit auf, die sich im Laufe der Zeit verstärkt, während Google Ads keinen Traffic mehr generiert, sobald Sie aufhören zu zahlen. Unser Google SEO-Service konzentriert sich auf organische Rankings, die dauerhafte Ergebnisse ohne wiederkehrende Werbekosten liefern.'
        },
        which_companies: {
          question: 'Mit welchen Unternehmen arbeiten Sie zusammen?',
          answer: 'Wir arbeiten mit lokalen Unternehmen aller Branchen zusammen, die ihren lokalen Markt auf Google dominieren wollen. Dazu gehören Zahnarztpraxen, Anwaltskanzleien, Installateure, Elektriker, Immobilienmakler, Autowerkstätten, Friseursalons und viele mehr. Wenn Sie einen physischen Standort haben oder ein bestimmtes geografisches Gebiet bedienen, ist unser Service genau für Sie gemacht.'
        },
        time_invest: {
          question: 'Wie viel Zeit muss ich investieren?',
          answer: 'Sehr wenig. Während des Onboardings verbringen Sie etwa 30 Minuten damit, uns die notwendigen Informationen über Ihr Unternehmen zu geben. Danach übernehmen wir alles. Sie erhalten regelmäßige Updates und Berichte, aber die tägliche Optimierungsarbeit wird vollständig von unserem Team verwaltet. Ihr Zeitaufwand ist minimal, damit Sie sich auf Ihr Geschäft konzentrieren können.'
        },
        contract_terms: {
          question: 'Wie sind die Vertragsbedingungen?',
          answer: 'Wir glauben daran, Ihr Vertrauen durch Ergebnisse zu verdienen, nicht durch lange Verträge. Unsere Pakete sind unkompliziert und transparent gestaltet. Wir besprechen die konkreten Konditionen während Ihres kostenlosen Analysegesprächs, bei dem wir den besten Ansatz basierend auf Ihrem Markt und Ihren Zielen empfehlen.'
        },
        get_started: {
          question: 'Wie können wir loslegen?',
          answer: 'Der Einstieg ist einfach. Wählen Sie ein Paket, das zu Ihren Bedürfnissen passt, und füllen Sie das Formular auf unserer Preisseite aus. Wir führen dann eine kostenlose Analyse Ihrer aktuellen Google Maps Präsenz durch und vereinbaren einen Termin, um Ihnen unsere Ergebnisse und empfohlene Strategie vorzustellen. Von dort an übernehmen wir den gesamten Prozess.'
        }
      }
    },
    guarantee: {
      badge: 'Unsere Garantie',
      title: 'Garantie',
      description: 'Falls wir nach 2 Monaten keine Verbesserungen sehen, arbeiten wir solange kostenlos weiter, bis wir Ihre Website auf der ersten Seite in Google gerankt haben.'
    },
    pricing_cta: {
      title: 'Bereit, Google zu dominieren?',
      subtitle: 'Verlieren Sie keine Kunden mehr an Ihre Konkurrenz. Holen Sie sich noch heute Ihre kostenlose Analyse und erfahren Sie genau, was nötig ist, um in die Top 3 zu kommen.',
      button: 'Kostenlose Analyse erhalten'
    },
    footer: {
      description: 'Wir helfen lokalen Unternehmen, Google Maps zu dominieren und durch bewährte Marketingstrategien mehr Kunden zu gewinnen.',
      quick_links: 'Schnellzugriff',
      contact: 'Kontakt',
      copyright: 'Simons Marketing Solutions. Alle Rechte vorbehalten.'
    }
  }
} as const;
